import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d8df9b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body d-flex flex-column justify-content-center text-center p-0" }
const _hoisted_2 = {
  class: "fs-1 fw-bolder d-flex justify-content-center thumbnail",
  style: {"min-height":"280px","max-height":"280px","box-shadow":"none","border-radius":"0.475rem 0.475rem 0 0","border-bottom":"1px solid #eff2f5"}
}
const _hoisted_3 = { class: "image-slot" }
const _hoisted_4 = { class: "fs-1 fw-bolder mt-2" }
const _hoisted_5 = { class: "fs-2 fw-bolder" }
const _hoisted_6 = {
  key: 0,
  class: "fs-5 symbol symbol-60px mt-10 mb-2"
}
const _hoisted_7 = { class: "d-flex flex-row gap-2 justify-content-center" }
const _hoisted_8 = { class: "d-flex flex-column time-wrapper" }
const _hoisted_9 = { class: "text-center time-counter" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Days", -1))
const _hoisted_11 = { class: "d-flex flex-column time-wrapper" }
const _hoisted_12 = { class: "text-center time-counter" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Hrs", -1))
const _hoisted_14 = { class: "d-flex flex-column time-wrapper" }
const _hoisted_15 = { class: "text-center time-counter" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Mins", -1))
const _hoisted_17 = { class: "d-flex flex-column time-wrapper" }
const _hoisted_18 = { class: "text-center time-counter" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Secs", -1))
const _hoisted_20 = {
  key: 0,
  class: "fs-5 symbol symbol-60px mt-10 mb-2"
}
const _hoisted_21 = { class: "d-flex flex-row gap-2 justify-content-center" }
const _hoisted_22 = { class: "d-flex flex-column time-wrapper" }
const _hoisted_23 = { class: "text-center time-counter" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Days", -1))
const _hoisted_25 = { class: "d-flex flex-column time-wrapper" }
const _hoisted_26 = { class: "text-center time-counter" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Hrs", -1))
const _hoisted_28 = { class: "d-flex flex-column time-wrapper" }
const _hoisted_29 = { class: "text-center time-counter" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Mins", -1))
const _hoisted_31 = { class: "d-flex flex-column time-wrapper" }
const _hoisted_32 = { class: "text-center time-counter" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, "Secs", -1))
const _hoisted_34 = { class: "text-center mb-5" }
const _hoisted_35 = { class: "fw-bolder mb-2 fs-4" }
const _hoisted_36 = { class: "text-center mb-5" }
const _hoisted_37 = {
  key: 0,
  class: "badge badge-outline badge-light-secondary badge-lg fs-3"
}
const _hoisted_38 = {
  key: 1,
  class: "badge badge-outline badge-light-primary badge-lg fs-3"
}
const _hoisted_39 = /*#__PURE__*/_createTextVNode("entries")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("entry")
const _hoisted_41 = { class: "mt-5 w-100 px-5" }
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Subscribe and Join ")
const _hoisted_43 = ["disabled"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Get More Entries", -1))
const _hoisted_45 = [
  _hoisted_44
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_picture = _resolveComponent("icon-picture")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_vue_countdown = _resolveComponent("vue-countdown")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", _ctx.cardClass]),
    style: {"min-height":"300px"}
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_image, {
          src: _ctx.draw.draw_image_src,
          class: "align-middle",
          lazy: "",
          fit: "contain",
          style: {"width":"auto","max-width":"100%","height":"auto","max-height":"280px"}
        }, {
          error: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_icon_picture)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(" Win " + _toDisplayString(_ctx.getPrize) + " on ", 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.getDrawDateFormatted), 1)
      ]),
      (_ctx.draw.status === 'open' && _ctx.draw.time_counter > 0)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.getDrawDate !== 'Not Specified')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_vue_countdown, {
                    time: _ctx.getCountdown,
                    onProgress: _ctx.handleCountdownProgress,
                    onEnd: _ctx.handleCountdownEnd
                  }, {
                    default: _withCtx(({ days, hours, minutes, seconds }) => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(days.toString().padStart(2, '0')), 1),
                          _hoisted_10
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(hours.toString().padStart(2, '0')), 1),
                          _hoisted_13
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(minutes.toString().padStart(2, '0')), 1),
                          _hoisted_16
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, _toDisplayString(seconds.toString().padStart(2, '0')), 1),
                          _hoisted_19
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["time", "onProgress", "onEnd"])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.getDrawDate !== 'Not Specified')
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, _toDisplayString(`00`.toString().padStart(2, '0')), 1),
                      _hoisted_24
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, _toDisplayString(`00`.toString().padStart(2, '0')), 1),
                      _hoisted_27
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, _toDisplayString(`00`.toString().padStart(2, '0')), 1),
                      _hoisted_30
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, _toDisplayString(`00`.toString().padStart(2, '0')), 1),
                      _hoisted_33
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.getDaysRemaining), 1)
    ]),
    _createElementVNode("div", _hoisted_36, [
      (['new'].includes(_ctx.draw.status))
        ? (_openBlock(), _createElementBlock("span", _hoisted_37, " To Be Opened "))
        : _createCommentVNode("", true),
      (['open', 'close', 'initialized'].includes(_ctx.draw.status))
        ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
            _createTextVNode(" You have " + _toDisplayString(_ctx.computeTotalEntries) + " ", 1),
            (_ctx.computeTotalEntries > 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_39
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_40
                ], 64))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_41, [
        (!_ctx.computeTotalEntries)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: "/plan",
              class: "btn btn-secondary fs-3 fw-bolder w-100"
            }, {
              default: _withCtx(() => [
                _hoisted_42
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (
            _ctx.computeTotalEntries &&
            ['new', 'open', 'close', 'initialized'].includes(_ctx.draw.status)
          )
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.viewDraw && _ctx.viewDraw(...args))),
              disabled: !_ctx.hasBundles,
              class: _normalizeClass(["btn btn-secondary fs-3 fw-bolder w-100", {
              disabled:
                !_ctx.hasBundles ||
                ['new', 'close', 'initialized'].includes(_ctx.draw.status),
            }])
            }, _hoisted_45, 10, _hoisted_43))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}